import { config } from '../../../../config/config';

/**
 * Hosted API reference on the Music24 website — authentication, the endpoint
 * surface, the MCP server and the per-plan limits. Built from the configured
 * website URL so staging points at the staging site.
 */
export const API_DOCS_URL = `${config.smartLinksWebURL}en/api-docs`;
